/**
 * CPIP re-entry build guard (P81-148827). Must stay the first import in App.tsx, and must
 * not import anything: any other module may already be the previous build's copy.
 *
 * CPIP re-executes this bundle in the same tab on every re-entry. If the build that ran
 * here before is a different one (a deploy happened in between, and the entry file is
 * served no-cache, so re-entry fetches the new build), the webpack runtime has already
 * absorbed that build's chunks from the shared chunk array before this module runs: their
 * module factories replaced ours, their chunk ids count as installed so ours are never
 * fetched, and cpip-share-init would hand us that build's shared singletons. Nothing else
 * has been evaluated yet at this point, so a page reload is still clean. The same build
 * passes straight through.
 *
 * Throwing stops the entry before webpack assigns this build's exports to the library
 * global, so until the page goes away the portal keeps what the previous build left there.
 * At most one reload per target build per RELOAD_WINDOW_MS: a reload that did not produce
 * a clean page must not turn into a loop. Inspect: window.__P81_WEBCLIENT_BUILD__
 */

/* global __webpack_hash__ */
const BUILD_KEY = "__P81_WEBCLIENT_BUILD__";
// Left in the tab by every build since P81-129790, including builds without this guard.
const PREVIOUS_BUILD_MARKER = "__CPIP_SHARE_SCOPE__";
// Also read by tools/versionManager, which skips its own reload right after ours.
const RELOAD_KEY = "cpipBuildGuardReload";
const RELOAD_WINDOW_MS = 60 * 1000;

// Fails closed: when the record cannot be read, assume a reload just happened.
const reloadedRecently = (win, build) => {
  try {
    const last = JSON.parse(win.sessionStorage.getItem(RELOAD_KEY) || "null");
    return !!last && last.to === build && Date.now() - last.at < RELOAD_WINDOW_MS;
  } catch {
    return true;
  }
};

const reload = (win, build) => {
  try {
    win.sessionStorage.setItem(RELOAD_KEY, JSON.stringify({ to: build, at: Date.now() }));
  } catch {
    return; // no record means no loop protection, so do not reload
  }
  win.location.reload();
};

export const runBuildGuard = (win, build) => {
  if (!win || !build) return;
  const previous = win[BUILD_KEY];
  const differentBuild = previous ? previous !== build : PREVIOUS_BUILD_MARKER in win;
  if (!differentBuild) {
    win[BUILD_KEY] = build;
    return;
  }
  if (!reloadedRecently(win, build)) reload(win, build);
  const error = new Error("A different SASE build already ran in this tab.");
  error.name = "CpipBuildChangedError";
  throw error;
};

runBuildGuard(
  typeof window !== "undefined" ? window : null,
  typeof __webpack_hash__ !== "undefined" ? __webpack_hash__ : null,
);
